import { useState } from 'react';
import { ReferenceArrayInput, ReferenceInput, required, SelectArrayInput, SelectInput, useInput, useNotify } from 'react-admin';
import { TextField } from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import { RichTextInput, RichTextInputProps } from 'ra-input-rich-text';
import { ISpeaker } from '../../types';
import CreateSimpleItemDialogButton from './CreateSimpleItemDialogButton';

export const LocationField = () => {
  const [forceReload, setForceReload] = useState(false);
  const doForceReload = () => {
    setForceReload(!forceReload);
  };

  return (
    <>
      <ReferenceArrayInput
        source="locationsId"
        reference="locations"
        sort={{ field: 'title', order: 'ASC' }}
        perPage={10000}
        options={{ forceReload }}
      >
        <SelectArrayInput optionText="title" />
      </ReferenceArrayInput>
      <CreateSimpleItemDialogButton resource={'locations'} onChange={doForceReload} fieldNames="title" />
    </>
  );
};

interface ISpeakersFieldProps {
  value?: string[];
  options?: any;
}
export const SpeakersField = (props: ISpeakersFieldProps) => {
  const [forceReload, setForceReload] = useState(false);
  const doForceReload = () => {
    setForceReload(!forceReload);
  };
  return (
    <>
      <ReferenceArrayInput
        source="speakersId"
        reference="speakers"
        sort={{ field: 'lastname', order: 'ASC' }}
        perPage={10000}
        options={{ forceReload }}
      >
        <SelectArrayInput optionText={(rec: ISpeaker) => `${rec.lastname}, ${rec.firstname}`} {...props} />
      </ReferenceArrayInput>
      <CreateSimpleItemDialogButton resource={'speakers'} onChange={doForceReload} fieldNames={['firstname', 'lastname']} />
    </>
  );
};

export const TagssField = () => {
  const [forceReload, setForceReload] = useState(false);
  const doForceReload = () => {
    setForceReload(!forceReload);
  };
  return (
    <>
      <ReferenceArrayInput
        source="tagsId"
        reference="tags"
        sort={{ field: 'title', order: 'ASC' }}
        perPage={10000}
        options={{ forceReload }}
      >
        <SelectArrayInput optionText="title" />
      </ReferenceArrayInput>
      <CreateSimpleItemDialogButton resource={'tags'} onChange={doForceReload} fieldNames="title" />
    </>
  );
};

export const CountryInput = () => {
  const [forceReload, setForceReload] = useState(false);
  const doForceReload = () => {
    setForceReload(!forceReload);
  };
  return (
    <>
      <ReferenceInput
        source="countryId"
        reference="countries"
        options={{ forceReload }}
        sort={{ field: 'title', order: 'ASC' }}
        perPage={10000}
      >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <CreateSimpleItemDialogButton resource={'countries'} onChange={doForceReload} fieldNames="title" />
    </>
  );
};

export const PathssField = () => {
  const [forceReload, setForceReload] = useState(false);
  const doForceReload = () => {
    setForceReload(!forceReload);
  };
  return (
    <>
      <ReferenceArrayInput
        source="pathsId"
        reference="paths"
        sort={{ field: 'title', order: 'ASC' }}
        perPage={10000}
        options={{ forceReload }}
      >
        <SelectArrayInput optionText="title" />
      </ReferenceArrayInput>
      <CreateSimpleItemDialogButton resource={'paths'} onChange={doForceReload} fieldNames="title" />
    </>
  );
};

const SelectTimeField = (props: any) => {
  const {
    field: { value, onChange },
    fieldState: { isTouched, error },
    isRequired,
  } = useInput(props);
  
  // Handle undefined or empty values
  const timeValue = value || '08:00'; // Default fallback
  const [hh, mm] = (timeValue as string).split(':');
  
  const dt = new Date();
  dt.setHours(Number(hh) || 8);
  dt.setMinutes(Number(mm) || 0);
  const [selectedDate, setSelectedDate] = useState(dt);
  const notify = useNotify();

  const handleDateChange = (evt: any) => {
    const H = evt.getHours();
    const M = evt.getMinutes();
    const HH = H < 10 ? `0${H}` : `${H}`;
    const MM = M < 10 ? `0${M}` : `${M}`;
    onChange(`${HH}:${MM}`);
    setSelectedDate(evt);
  };

  if (error && isTouched) {
    notify(error.message || 'oops, error', { type: 'warning' });
  }

  return (
    <MobileTimePicker
      label={props.label || props.source}
      value={selectedDate}
      onChange={handleDateChange}
      renderInput={params => <TextField required={isRequired} {...params} />}
      minutesStep={5}
    />
  );
};

export const DatesField = () => {
  return (
    <>
      <ReferenceInput source="dateId" reference="dates" validate={[required()]}>
        <SelectInput optionText="date" validate={[required()]} />
      </ReferenceInput>
      &nbsp;&nbsp;&nbsp;
      <SelectTimeField source="start" validate={[required()]} />
      &nbsp;&nbsp;
      <SelectTimeField source="end" validate={[required()]} />
    </>
  );
};

export const RichText = (props: RichTextInputProps) => (
  <div
    style={{ borderStyle: 'outset', borderWidth: '2px', padding: '10px' }}
    className="MuiOutlinedInput-root MuiInputBase-root MuiInputBase-fullWidth"
  >
    <RichTextInput {...props} />
    {/* <RichTextInput multiline {...props} /> */}
  </div>
);
